var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flow-command',{attrs:{"name":_vm.command}},[_c('div',{staticClass:"item"},[_c('span',{staticClass:"material-icons-round"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }